// extracted by mini-css-extract-plugin
var _1 = "ProfileActionsWidgetItem-moduleProfileActionsWidgetItem__i_nPn";
var _2 = "ProfileActionsWidgetItem-moduletooltipWrapper__j6ewQ";
export { _1 as "ProfileActionsWidgetItem", _2 as "tooltipWrapper" }
